import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f55bc3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-bottom":"200px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Price", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }),
            _createVNode(_component_ion_title, { style: {"font-family":"'Montserrat', sans-serif","font-weight":"700","text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data ? 'Edit' : 'Add') + " Material Expense", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-no-padding",
      style: {"--background":"white"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, { style: {"margin-right":"15px"} }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_ion_datetime_button, {
                    slot: "end",
                    datetime: "dateMaterialExpense"
                  }),
                  _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_datetime, {
                        id: "dateMaterialExpense",
                        presentation: "date",
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                        "format-options": _ctx.formatOptions,
                        "show-default-buttons": true
                      }, null, 8, ["modelValue", "format-options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_textarea, {
                    autoGrow: "",
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                    labelPlacement: "floating",
                    label: "Description",
                    counter: true,
                    maxlength: "128"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { style: {"margin-right":"15px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.quantity,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quantity) = $event)),
                    type: "number",
                    label: "Quantity",
                    labelPlacement: "floating"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { style: {"margin-right":"15px"} }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_CurrencyInput, {
                    slot: "end",
                    modelValue: _ctx.price,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.price) = $event)),
                    options: { currency: _ctx.store.userCurrency }
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ion_grid, { class: "ldx-bottom-fixed" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                      color: "medium",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                      color: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirm()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}